import { Fragment } from "react";
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import { inputClasses } from "../../styles/inputs";

import { useState } from "react";

const RenderDropdown = ({ classes, options, onSelect, def }) => {

    const inputClass = inputClasses();
    const [isOpen, setIsOpen] = useState(false);
    const [option, setOption] = useState(def);

    const handleDropdownAction = () => setIsOpen(!isOpen);

    const handleOptionChange = (option) => {
        setOption(option)
        setIsOpen(false);
        onSelect(option);
    }

    classes = classes.reduce((cls, c) => cls + " " + inputClass[c], "");
    return (
        <div style={{ width: "100%" }}>

            {/* DROPDOWN SELECTOR */}
            <div className={classes + " " + inputClass.dropdownSelector + " " + (isOpen ? inputClass.dropdownOpen : "")} onClick={handleDropdownAction} >
                {/* DEFAULT OPTION */}
                <div className={inputClass.width80 + " " + inputClass.textCenter}>
                    {option?.caption || "Industria"}
                </div>
                {/* ICON */}
                <div className={inputClass.width10 + " " + inputClass.textCenter}> {
                    isOpen ? <ArrowDropUp sx={{ cursor: "pointer" }}></ArrowDropUp>
                        : <ArrowDropDown sx={{ cursor: "pointer" }}></ArrowDropDown>
                } </div>
            </div>

            {/* DROPDOWN OPTIONS */}
            {isOpen && <div className={inputClass.dropdownOptionsContainer}>
                {options.map(
                    (o, i) => <div key={i} className={inputClass.dropdownOption} onClick={() => handleOptionChange(o)} > {o.caption} </div>
                )}
            </div>}
        </div>
    );
}

export const Dropdown = ({ options = ["Empty"], classes = [], onSelect, def = null }) => (
    <Fragment>
        <RenderDropdown {...{ options, classes, onSelect, def }} />
    </Fragment>
);
